import React from "react";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    color?: string;
    icon?: "plus" | "back";
    label: string;
    toId: string;
}

const BackToId: React.FC<ButtonProps> = ({
    children,
    className = "cta",
    type = "button",
    color = "primary",
    icon,
    label,
    toId,
    ...props
}) => {
    return (
        <div className="container--gototop">
            <button
                type="button"
                className={`${className} ${className}--${color} ${icon ? icon : ""}`}
                title={label}
                onClick={() => {
                    const element = document.getElementById(toId);
                    if (element) {
                        const elementPosition = element.getBoundingClientRect().top;
                        const bannerHeight = 80;
                        window.scrollBy(0, elementPosition - bannerHeight);
                    }
                }}
            >
                {label}
            </button>
        </div>
    );
};
export default BackToId;